module.exports = __webpack_public_path__ + "static/69-d7c82bcb021bd60b9c618d89d091b33a.png";